var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record.thumbnail)?_c('img',{class:_vm.classes,attrs:{"src":_vm.record.thumbnail,"width":"160"},on:{"click":function($event){$event.stopPropagation();return _vm.openFullframeImageViewer.apply(null, arguments)}}}):_c('span',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }